<template>
  <div class="bid-box">
    <div class="option-box">
      <div class="option-sty">
        <p>招标公告</p>
      </div>
    </div>
    <div class="list-flex">
      <div class="bid-list">
        <div v-if="newsList.length>0">
          <ul class="first-ul">
            <li style="cursor: pointer" v-for="(item,index) in newsList" :key="index" @click="downloadIt(item)">
              <p>[{{item.F_CreateTime.substring(0,10)}}]&nbsp;&nbsp;&nbsp;&nbsp;<span>{{item.F_Title}}</span></p>
            </li>
          </ul>
          <el-pagination background
                         style="margin-top: 10px;margin-bottom: 20px;"
                         layout=" total, prev, pager, next"
                         :current-page="currentpage"
                         :page-size="pageSize"
                         :total="TotalCount"
                         @current-change="onCurrentChange"
          >
          </el-pagination>
        </div>
        <div v-else style="padding: 20px 0px;">
          <p style="text-align: center">
            <img src="/static/images/bid/u476.png">
          </p>
          <p style="font-size: 18px;font-weight: 600;text-align: center;color: #888888;">暂无数据</p>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        form:{
          AuctionState:'Executing',
        },
        newsLoading:false,
        newsList:[],
        PageIndex:1,
        url:{
          list:SZH.assets.api + '/Market/GetPagingNews',
        },
        currentpage:1,
        TotalCount:0,
        pageSize:10,
      }
    },
    methods: {

      onCurrentChange(v){
        this.PageIndex = v;
        this.getBidList();
      },
      search(){

      },
      downloadIt(item) {
        this.$router.push({
          path: '/Menu/AuctionDownload',
          query: {
            Id: item.F_Id
          }
        });
        // console.log(item)
        // window.open(SZH.assets.image + '/' + item.F_AttachUrl)
      },
      getBidList(){
        let self = this;
        self.$http.post(self.url.list,{
          PageSize:10,
          PageIndex:self.PageIndex,
          Data:{}
        }).then(result =>{
          if(result.state == true){
            self.TotalCount = result.data.TotalCount;
            self.newsList = result.data.Data;
          }else{
            self.newsList= [];
            self.TotalCount = 0;
            // self.$message.error('未查到数据');
          }
        }, () => {
          self.$message.error('数据保存失败，请检查您的网络是否可用。');
        });
      },
    },
    destroyed(){
    },
    computed: {

    },
    components: {},
    mounted() {
      this.getBidList();
    }
  }
</script>
<style type="text/css" src="./News.css" scoped></style>



// WEBPACK FOOTER //
// src/views/AuctionHall/News/News.vue